module.exports = __webpack_public_path__ + "static/logo-dark-c8180e3af86c4fb67420be1d00cfaf13.png";